export default ({ axios, mapQueryString }) => ({
    company: (query = {}) => axios.get(`/branch-geofences${mapQueryString(query)}`)
})


// WEBPACK FOOTER //
// ./src/api/branchGeofences.js